import React, { useState, useEffect } from 'react';
import { Form, Input, Button, message, Select, Col, Row} from 'antd';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';

const ManageBanner: React.FC = ({}) => {
  const [items, setImageCategoryData] = useState<[]>([]);
  const [subitems, setImageSubCategoryData] = useState<[]>([]);
  const [selectedItem, setSelectedImageCategory] = useState('');
  const [selectedSubItem, setSelectedImageSubCategory] = useState('');
  const [bannerText, setBannerText] = useState('');
  const [selectedImage, setSelectedImage] = useState<File | null>(null);

  const { instance, accounts } = useMsal();

  const API_URL = process.env.REACT_APP_API_URL;

  const fetchToken = async () => {
        const res = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        return res.idToken;
      };
    
      useEffect(() => {
        fetchToken();
        getImageCategoryData();
      }, []);
      
        // File size limit (in bytes)
        const max_file_size = 500 * 1024; // 500 KB
        // Allowed file extensions
        const allowed_extension = ['jpg', 'jpeg', 'png', 'gif'];

  const handleSubmit = async () => {
    if (!selectedItem || !bannerText || !selectedImage) {
      message.error('Please fill all fields');
      return;
    }   

    if (selectedImage.size > max_file_size) {
      message.error('File size exceeds 500 KB limit.');
      return;
    }
    const file_extension = selectedImage.name.split('.').pop()?.toLowerCase();
    if (!allowed_extension.includes(file_extension || '')) {
      message.error('Invalid file type. Only jpg, jpeg, png and .gif are allowed.');
      return;
    }
    const userId = localStorage.getItem("UserId");

    const formData = new FormData();
    formData.append('file', selectedImage); // Append the image file
    formData.append('ImageCategoryId', selectedItem); // Append the text data
    formData.append('ImageSubCategoryId', selectedSubItem);
    formData.append('BannerText', bannerText);
    formData.append('CreatedBy', userId || '');

    try {
      const token = await fetchToken();
      await axios.post(`${API_URL}/api/Banner/SaveBanners`, formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
        message.success('Banners added successfully');
        setSelectedImageCategory('');
        setSelectedImageSubCategory('');
        setBannerText('');
    } catch (error) {
        message.error('Failed to save the data');
    }
  };

  const handleSelectedChange = (value: string) => {
    setSelectedImageCategory(value);
    getImageSubCategoryData(value);
  }

  const handleSelectedSubCatChange = (value: string) => {
    setSelectedImageSubCategory(value);
  }

  const getImageCategoryData = async () => {
    try {
      const token = await fetchToken();
      const response = await axios.get(`${API_URL}/api/Banner/GetImageCategoryName`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      
      setImageCategoryData(response.data);
    } catch (error) {
      message.error('Failed to load image category data');
    }
  }

  const getImageSubCategoryData = async (imagecategoryid: string) => {
    try {
      const token = await fetchToken();
      const response = await axios.get(`${API_URL}/api/Banner/GetImageSubCategoryName/${imagecategoryid}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });
      if(response.data.length === 0){
        setSelectedImageSubCategory('');
        setImageSubCategoryData([]);
      }
      else{
        setSelectedImageSubCategory('');
        setImageSubCategoryData(response.data);
      }
    } catch (error) {
      message.error('Failed to load image sub category data');
    }
  }

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      setSelectedImage(file);
    }
  }

  return (
    <Form layout="vertical" onFinish={handleSubmit}>
        <Row gutter={16}>
            <Col span={12}>
                <Form.Item label="Image Category Name" required>
                    <Select
                        value={selectedItem}
                        onChange={handleSelectedChange}
                    >
                        {items.map((type: any) => (
                        <option key={type.value} value={type.value}>
                            {type.text}
                        </option>
                        ))}
                    </Select>
                </Form.Item>
            </Col>
            <Col span={12}>
                <Form.Item label="Image Sub Category Name">
                    <Select
                        value={selectedSubItem}
                        onChange={handleSelectedSubCatChange}
                    >
                        {subitems.map((type: any) => (
                        <option key={type.value} value={type.value}>
                            {type.text}
                        </option>
                        ))}
                    </Select>
                </Form.Item>
            </Col>
        </Row>
        <Row gutter={16}>
            <Col span={12}>
                <Form.Item label="Banner Text" required>
                    <Input
                        value={bannerText}
                        onChange={(e) => setBannerText(e.target.value)}
                        placeholder="Enter Banner Text" maxLength={150}
                    />
                </Form.Item>
            </Col>
            <Col span={12}>
                <Form.Item label="Upload Image" required>
                    <Input type='file' accept='image/*' onChange={handleFileUpload}></Input>
                </Form.Item>
            </Col>
        </Row>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Save
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ManageBanner;